import React from "react";
import { LENDERS } from "../../consts/tables";
import LenderInfo from "./LenderInfo";
import LenderProperty from "./LenderProperty";
import NotesInfo from "./NotesInfo";
import CRUD from "../CRUD/CRUD";
import { getCurrentAccess } from "../../access";
import { editsEverySummitRecord } from "../../access-levels";
import { browserHistory } from "react-router";
import { getData, manageData } from "../../requests/CRUD";

export default class CRUDLender extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null,
            original: null,
            isBusy: null,
            error: null,
            success: null,
            errorTabs: [],
            currentTab: 0,
            viewMode: this.props.edit || false,
            propertiesData:[]
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChangeInput = this.handleChangeInput.bind(this);
        this.saveData = this.saveData.bind(this);
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
        this.setPropertiesData = this.setPropertiesData.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.params.id !== nextProps.params.id) {
            this.fetch(nextProps.params.id);
        }
    }

    componentDidMount() {
        this.fetch(this.props.params.id);
    }

    fetch(id) {
        this.setState({
            data: null,
            error: null,
            success: null,
        });

        if (id === undefined) {
            this.setState({
                data: {},
            });
            return;
        }

        getData({
            tableCode: LENDERS,
            options: {
                filter: [
                    {
                        text: id,
                        code: "ARCIMEDES_ROW_ID",
                        type: "exact",
                    },
                ],
            },
        }).then((res) => {
            if (res && res.success && Array.isArray(res.data) && res.data.length) {
                this.setState({
                    data: res.data[0],
                    original: { ...res.data[0] },
                    error: null,
                });
            } else {
                this.setState({
                    data: false,
                    error: res.message ? res.message : "Unidentified Error",
                });
            }
        });
    }

    handleSubmit(e) {
        e.preventDefault();

        if (this.state.viewMode) this.setState({ viewMode: false });

        if (
            this.state.isBusy ||
            this.state.data.NAME === "" ||
            this.state.viewMode === true
        )
            return;

        this.setState({ viewMode: true }, () => this.saveData());
    }

    handleChangeInput(key, value) {
        this.setState({
            data: Object.assign(this.state.data, {
                [key]: value,
            }),
        });
    }

    handleChangeDropdown(query, queryType, x, key) {
        this.setState({
            data: Object.assign(this.state.data, {
                [key]: query[key],
            }),
        });
    }
    setPropertiesData(data){
        this.setState({propertiesData:data})
    }

    saveData() {
        if (this.state.isBusy) return;
        let self=this;

        this.setState({
            isBusy: true,
            error: null,
            success: null,
        });

        return manageData({ tableCode: LENDERS, data: [this.state.data] }).then(
            (res) => {
                if (res && res.success) {
                    this.setState(
                        {
                            isBusy: false,
                            success: "Saved",
                            original:self.state.data                            
                        },
                        () => {
                            if (!this.props.edit) {
                                browserHistory.push({
                                    pathname: `/lender/${res.data[0].ARCIMEDES_ROW_ID}`,
                                });
                            }
                        }
                    );
                    window.scrollTo(0, 0);
                } else {
                    this.setState({
                        isBusy: null,
                        error: res && res.message ? res.message : "Unspecified error",
                    });
                }
            }
        );
    }

    render() {
        const data = this.state.data;
        const { edit } = this.props;

        return (
            <CRUD
                tabsData={[
                    {
                        name: "LENDER",
                        renderedComponent: (
                            <LenderInfo
                                data={data}
                                handleChangeInput={this.handleChangeInput}
                                handleChangeDropdown={this.handleChangeDropdown}
                                viewMode={this.state.viewMode}
                                deleted={data && data.DELETED === "1"}
                            />
                        ),
                    },
                    {
                        name: "NOTES",
                        renderedComponent: (
                            <NotesInfo  
                            data={data} 
                            viewMode={this.state.viewMode}        
                            handleChangeInput={this.handleChangeInput}
                            deleted={data && data.DELETED === "1"}/>
                        ),
                    },
                    {
                        name: "Properties",
                        renderedComponent: (
                            <LenderProperty data={data} propertiesData={this.state.propertiesData} setPropertiesData={this.setPropertiesData}/>
                        ),
                    },
                ]}
                backLink={`${arc.path.base}lenders`}
                edit={edit}
                state={this.state}
                setState={this.setState.bind(this)}
                handleSubmit={this.handleSubmit}
                saveData={this.saveData}
                type="lender"
                backName="LENDERS"
                title={data && `${data.NAME} - ${data.CITY ? data.CITY : ''}, ${data.STATE ? data.STATE : ''}`}
                /* Edit and Delete for whoever edits every SUMMIT record (the old admin rule). */
                forceActions={editsEverySummitRecord(getCurrentAccess())}
            />
        );
    }
}
